import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  Inject,
} from '@angular/core';
import {
  GatewayConfig,
  SHARED_GATEWAY_CONFIG,
} from '@cigna/shared/angular/gateways-util';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { CfbFeatureFlagService } from '@cigna/cigna-for-brokers/shared/util';

const LOCAL_LOGO_PATH = 'assets/images/cignahlthcr_logo_color.svg';
const CDN_LOGO_PATH =
  'spa/cigna-for-brokers/assets/images/cignahlthcr_logo_color.svg';

@Component({
  selector: 'cigna-header-logo',
  templateUrl: './header-logo.component.html',
  styleUrls: ['./header-logo.component.scss'],
})
export class HeaderLogoComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() resizeSideNavToggle: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() enableToggleSidNav: boolean;
  @Input() isFromLogin: boolean;
  @Input() isImpersonator: boolean;
  @Output() resizeSideNavToggleEmit = new EventEmitter<{ open: boolean }>();
  isIntegrationOn = false;
  readonly logoPath: string;

  constructor(
    @Inject(SHARED_GATEWAY_CONFIG) gatewayConfig: GatewayConfig,
    private cfbFeatureFlagService: CfbFeatureFlagService,
  ) {
    const cdn = gatewayConfig.cdn;
    this.logoPath =
      !cdn || cdn.includes('localhost') ? LOCAL_LOGO_PATH : CDN_LOGO_PATH;
  }

  ngOnInit(): void {
    this.isIntegrationOn = this.cfbFeatureFlagService.isIntegrationOn();
  }

  resizeSideNavToggleFn(): void {
    this.resizeSideNavToggle = !this.resizeSideNavToggle;
    this.resizeSideNavToggleEmit.next({ open: this.resizeSideNavToggle });
  }
}
